import {

            ADD_POKEMON_TO_WISHLIST_REQUEST,
            ADD_POKEMON_TO_WISHLIST_SUCCESS,
            ADD_POKEMON_TO_WISHLIST_FAIL,
            // ALREADY_ADDED_TO_WISHLIST_SUCCESS,

            REMOVE_FROM_WISHLIST_SUCCESS,
            REMOVE_FROM_WISHLIST_FAIL,
            
            ADD_POKEMON_TO_CART_SUCCESS, 
            // ADD_POKEMON_TO_CART_REQUEST,
            ADD_POKEMON_TO_CART_FAIL ,

            REMOVE_POKEMON_FROM_CART_SUCCESS ,
            REMOVE_POKEMON_FROM_CART_FAIL ,

            CLEAR_ERRORS
} from "../constants/cartAndWishlistConstants";

//add to cart
export const cartReducer  = (state = {cartItem:{}} , action ) => {

        switch(action.type){
                      //__________________--add to cart
           case ADD_POKEMON_TO_CART_SUCCESS:

              try {
                  //     let objLength = Object.getOwnPropertyNames(state.cartItem).length;
    
                      return{
                            cartItem : action.payload, 
                            loading: false
                      } 
                    
              } catch (error) {
                    console.log(error)                    
              }

              //__________remove
           case REMOVE_POKEMON_FROM_CART_SUCCESS:
                     
              try {

                  return ({
                        ...state,
                        cartItem: action.payload,
                        loading: false                                              
                     })
                    
              } catch (error) {
                 console.log(error)    
              }
           case REMOVE_POKEMON_FROM_CART_FAIL,
                ADD_POKEMON_TO_CART_FAIL:
                 return{
                       ...state,
                       loading: true,
                       error: "failed to add or remove item from cart"
                 }          
           case CLEAR_ERRORS:
                  return {
                      ...state,
                      error: null
                  }
          default: return state; 
         
       }
}


// save to wish list
 export const addPokemonToWishList  = (state = {wishListItems:[ ], message:"", cartItem:{}} , action ) => {


      let item = action.payload;

    switch(action.type){

            case ADD_POKEMON_TO_WISHLIST_REQUEST:
                  return {
                      ...state,
                      loading: true
                  }

            case ADD_POKEMON_TO_WISHLIST_SUCCESS: 

                   try {                        
               
                      const isSaved = state.wishListItems.find((el) => el.id === item.id)
                          if(isSaved){

                                  return {
                                              wishListItems: state.wishListItems.map(el=> el.id === isSaved.id? item:el),
                                          }
                          }else{

                                  return{
                                          wishListItems: [...state.wishListItems, item],
                                          message: state.message = "item has been saved"
                                    }                                                      

                          }                         
                     
                        } catch (error) {
                           console.log(error) 
                        }

                  return {
                    //   ...state,
                       wishListItems: [...state.wishListItems, item ],
                       loading: false,
                  }
   
           case ADD_POKEMON_TO_WISHLIST_FAIL: 
                  return {
                  //___add logic test
                  ...state,
                  loading: true,
                  error: "failed to add item to wishlist"
                }
               //__________remove
            case REMOVE_FROM_WISHLIST_SUCCESS:
                  let itemId = action.payload;
                      
                 return ({
                     ...state,
                     wishListItems: state.wishListItems.filter((el) => el.id !== itemId)                          ,
                  }) 
             //___not tested      
            case REMOVE_POKEMON_FROM_CART_FAIL,
                   REMOVE_FROM_WISHLIST_FAIL : 
                   return {
                        ...state,
                        loading: true,
                        error: "failed to remove item"
                    } 
           case CLEAR_ERRORS:
                        return {
                            ...state,
                            error: null
            }            

            default: return state; 
                                 
      }
}
